import * as THREE from 'three';
import { PAINTINGS } from '../config';

export interface LoadedPainting {
  texture: THREE.Texture;
  loaded: boolean;
  /** 이 명화가 나타날 때 입자가 물드는 색. */
  particleColor: THREE.Color;
}

/**
 * 6점의 명화 텍스처를 비동기 로드하고 보관한다. 로드 전엔 loaded=false라
 * WallSurface가 명화를 띄우지 않고 황금 추상으로 남는다(점진적 등장).
 */
export class PaintingLibrary {
  readonly paintings: LoadedPainting[];

  constructor() {
    const loader = new THREE.TextureLoader();
    this.paintings = PAINTINGS.map((p) => {
      const entry: LoadedPainting = {
        texture: new THREE.Texture(),
        loaded: false,
        particleColor: new THREE.Color(p.particleColor),
      };
      loader.load(
        `${import.meta.env.BASE_URL}${p.path}`,
        (texture) => {
          texture.colorSpace = THREE.SRGBColorSpace;
          texture.minFilter = THREE.LinearMipmapLinearFilter;
          texture.magFilter = THREE.LinearFilter;
          texture.anisotropy = 4;
          entry.texture = texture;
          entry.loaded = true;
        },
        undefined,
        (error) => console.warn(`명화 로드 실패: ${p.path}`, error),
      );
      return entry;
    });
  }

  get count(): number {
    return this.paintings.length;
  }

  get(index: number): LoadedPainting {
    return this.paintings[index];
  }

  /** 6점의 particleColor 팔레트 (피날레 다색 입자용). */
  palette(): THREE.Color[] {
    return this.paintings.map((p) => p.particleColor);
  }
}
